export default "__VITE_ASSET__Bv1oRi_S__"